import { PopupsActionsTypes } from "./popup.types";
import { axiosAutomationInstance } from "../../axios.config";

export const getPopups = () => (dispatch) => {
  dispatch({ type: PopupsActionsTypes.GET.POPUPS_PENDING });

  axiosAutomationInstance
    .get(`/popup/${process.env.REACT_APP_BOT_ID}`)
    .then((res) =>
      dispatch({
        type: PopupsActionsTypes.GET.POPUPS_SUCCESS,
        payload: res.data,
      })
    )
    .catch((error) =>
      dispatch({
        type: PopupsActionsTypes.GET.POPUPS_ERROR,
        payload: error,
      })
    );
};
